/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const LoadLevel = {
    None: 'None',
    Low: 'Low',
    High: 'High',
    Peak: 'Peak',
} as const;
export type LoadLevel = typeof LoadLevel[keyof typeof LoadLevel];

